export default {
  name: 'SocialGraph',
  displayName: {
    en: 'Social Graph',
    ja: 'ソーシャルグラフ',
  },
  defaultWidth: 375,
  defaultHeight: 667,
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'sortList',
      displayName: { en: 'Sorting', ja: '並び替え' },
      type: 'sort',
    },
    {
      name: 'maximumItems',
      displayName: { en: 'Maximum number of items', ja: '最大アイテム数' },
      type: 'maximumItems',
    },
  ],
  childComponents: [
    {
      name: 'sender',
      displayName: { en: 'Sender', ja: '送信者' },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'text',
          displayName: { en: 'Sender', ja: '送信者' },
          type: 'text',
          default: 'Title',
        },
      ],
    },
    {
      name: 'receiver',
      displayName: { en: 'Receiver', ja: '受信者' },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'text',
          displayName: { en: 'Receiver', ja: '受信者' },
          type: 'text',
          default: 'Title',
        },
      ],
    },
    {
      name: 'amount',
      displayName: { en: 'Amount Source', ja: '数量' },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'amount',
          displayName: { en: 'Amount Source', ja: '数量' },
          type: 'number',
        },
      ],
    },
    {
      name: 'amountDisplay',
      displayName: {
        en: 'Amount',
        ja: '数量表示',
      },
      props: [{ name: 'enabled', type: 'boolean', default: false }],
    },
    {
      name: 'hasIcon',
      displayName: {
        en: 'Icon',
        ja: 'アイコン表示',
      },
      props: [
        { name: 'enabled', type: 'boolean', default: false },
        {
          name: 'iconName',
          displayName: {
            en: 'Icon',
            ja: 'アイコン表示',
          },
          type: 'icon',
          default: 'account',
        },
      ],
    },
    {
      name: 'node',
      displayName: {
        en: 'Node',
        ja: 'ノード',
      },
      styles: {
        color: {
          displayName: {
            en: 'Color',
            ja: 'カラー',
          },
        },
        activeColor: true,
      },
    },
  ],
  style: {
    opacity: true,
    backgroundColor: true,
    shadow: true,
    color: true,
  },
};
